import axios from 'axios';
import FrameSpec from '@framebridge/toolbox/FrameSpec'

export const loadBundleSpec = async (joineryHost, bundleSpecNumber, authorizationToken) => {
  const authHeaders = authorizationToken ? { 'Framebridge-Resource-Authorization-Token': authorizationToken } : {};
  const res = await axios.get(`${joineryHost}/api/v1/bundle_specifications/${bundleSpecNumber}`, { headers: authHeaders });
  return {
    ...res.data,
    authorizationToken: authorizationToken,
  };
};

export const frameSpecsFromBundle = (bundleSpecData) => {
  return bundleSpecData.components.map((frame) => {
    return {
      ...frame.frameSpec,
      offsetInBundle: {
        leftInInches: frame.fromLeft,
        topInInches: frame.fromTop
      }
    };
  });
}

const cloneFrameSpecWithAddOns = async (frameSpecData, bundleAdditions, joineryHost) => {
  const frameSpec = await FrameSpec.build({
    frameSpecData,
    joineryHost,
    usedFullMats: [],
  });
  const frameSpecCopy = frameSpec.duplicate();
  await frameSpecCopy.saveToServer();

  const addOnItems = bundleAdditions
    .filter((addOn) => addOn.properties._parent_design === frameSpec.number)
    .map((addOn) => ({
      id: addOn.variant_id,
      properties: { _parent_design: frameSpecCopy.number }
    }));

  return {
    number: frameSpecCopy.number,
    offsetInBundle: frameSpecCopy.offsetInBundle,
    addOnItems,
  };
}

const cloneBundleSpec = async (bundleSpecData, clonedFrameSpecs, joineryHost) => {
  const response = await axios.post(`${joineryHost}/api/v1/bundle_specifications`, {
    include_token: true,
    bundle_specification: {
      hanging_guide_sku: bundleSpecData.hangingGuideSku || '',
      components_attributes: clonedFrameSpecs.map((frameSpec) => ({
        fs_number: frameSpec.number,
        from_top: frameSpec.offsetInBundle.topInInches,
        from_left: frameSpec.offsetInBundle.leftInInches,
      })),
      photo_tray: bundleSpecData.photoTray || null,
    },
  });

  return response.data;
};

export const duplicateBundleSpec = async (
  bundleSpecNumber,
  bundleSpecToken,
  variantId,
  itemProperties,
  bundleAdditions,
  duplicationCount,
  joineryHost
) => {
  const bundleSpecData = await loadBundleSpec(joineryHost, bundleSpecNumber, bundleSpecToken);
  const minimalistFrameSpecs = frameSpecsFromBundle(bundleSpecData);

  const bundleClones = await Promise.all(
    Array.from({ length: duplicationCount }).map(async () => {
      const clonedFrameSpecs = await Promise.all(
        minimalistFrameSpecs.map((frameSpecData) => cloneFrameSpecWithAddOns(frameSpecData, bundleAdditions, joineryHost))
      );
      const clonedBundleSpec = await cloneBundleSpec(bundleSpecData, clonedFrameSpecs, joineryHost);

      const addOnItems = clonedFrameSpecs
        .map((frameSpec) => frameSpec.addOnItems).flat()
        .map((addOnItem) => ({
          ...addOnItem,
          properties: { ...addOnItem.properties, _parent_bundle_spec: clonedBundleSpec.number }
        }));

      return {
        number: clonedBundleSpec.number,
        token: clonedBundleSpec.authorizationToken,
        addOnItems,
      };
    })
  );
  const addOnItems = bundleClones.map((bundle) => bundle.addOnItems).flat();

  const items = [
    ...bundleClones.map((bundle) => ({
      id: `${variantId}`,
      properties: {
        ...itemProperties,
        _bundle_spec_number: bundle.number,
        _bundle_spec_authorization_token: bundle.token,
      }
    })),
    ...addOnItems
  ];

  return items;
}
